import { PlanBenefit } from "capitalrx-types";
import { request } from "./request";

export interface EnrollmentPlan {
  plan: {
    id: number;
    client_id: "string";
  };
  plan_benefit: {
    coverage_strategy_id: string;
    coverage_strategy_type: string;
    plan_id: number;
  };
}

export async function getPlanBenefit(coverage_strategy_id: string): Promise<PlanBenefit> {
  return await request<PlanBenefit>({
    url: "/plan_benefit/get",
    method: "POST",
    data: {
      coverage_strategy_id: coverage_strategy_id,
    },
  });
}

export async function getPlan(enrollment_plan_csid_id: number): Promise<EnrollmentPlan> {
  return await request<EnrollmentPlan>({
    url: "/plan/get",
    method: "POST",
    data: {
      enrollment_plan_csid_id: enrollment_plan_csid_id,
    },
  });
}
